import { fetchEntities, createEntityWithDefaults } from "actions/entities";
import debounce from 'debounce'
import dotProp from 'dot-prop'
import pluralize from "pluralize";
import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { actions } from "react-redux-form"

import { getUiOptions } from 'selectors/forms'
import PaginatedSelectorFieldControl from "./PaginatedSelectorFieldControl";
import SelectorFieldControl from "./SelectorFieldControl";
import { getEntitiesForSelector, getEntityIdFromState, getEntityModel, mapEntitiesToSelectableOptions, withBlankOption } from "./selectorFieldOptions";

class SemanticPaginatedSelectorField extends React.Component {
  render() {
    return <PaginatedSelectorFieldControl {...this.props}/>
  }
}

const getKeyWindowName = (formEntityName) => formEntityName ? `${formEntityName}Form` : 'default'

const mapStateToProps = (state, ownProps) => {
  const options = getUiOptions(state, ownProps) || {}
  return {
    options: {...options, keyWindowName: getKeyWindowName(ownProps.formContext?.entityName)}
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateValue: (event, props) => {
      dispatch(actions.change(getEntityModel(ownProps), props.value))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SemanticPaginatedSelectorField);
